import styled from '@emotion/styled'
import { PrimaryButton } from '@mmsg/louie'
import { Col, Card } from 'react-bootstrap'

interface IInputProps {
  primary: boolean
}

export const BannerContainingDiv = styled.div`
  label: BannerContainingDiv;
  background-color: #e9ecef;
  padding: 37px;theme
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-height: 350px;
`

export const ProposalReviewPage = styled.div`
  label: ProposalReviewPage;
  > div:first-of-type {
    min-height: auto;
    font-weight: normal;
    h2 {
      font-size: 28px;
    }
    div {
      font-weight: normal;
    }
  }
`
export const BannerContent = styled.div`
  label: BannerContent;
  text-align: left;
  color: ${(props) => props.theme.colors.grey2};
  max-width: 1140px;
  margin: 40px auto;
  @media (max-width: 719px) {
    margin: 0 auto;
  }
`

export const CarName = styled.div`
  label: CarName;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 600 : 900)};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '34px')};
  color: #000;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem 1.25rem 0;
  text-align: center;
`

export const CarDescription = styled.div`
  label: CarDescription;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
`

export const CarBodySection = styled.div`
  label: CarBodySection;
  display: flex;
  > div:first-of-type {
    padding-right: 2px;
  }
`

export const CarImageSection = styled.div`
  label: CarImageSection;
  width: 50%;
  img {
    height: 214px;
  }
`

export const ProposalIcon = styled.span`
  label: ProposalIcon;
  position: absolute;
  left: 23px;
`

export const DeductionTotalContainer = styled.div`
  label: DeductionTotalContainer;
  display: flex;
  margin: 0 21px 21px 21px;
  border-radius: 4px;
  font-size: 14px;
  background: #f7f7f7;
  justify-content: space-between;
  & > div:first-of-type {
    padding: 10px 24px;
    flex-grow: 1;
  }
  div:nth-of-type(2) {
    margin: 0;
    h2 {
      font-size: 14px;
    }
    b {
      font-size: 24px;
      font-weight: 600;
    }
  }
`
export const DeductionTotalBlock = styled('div')<IInputProps>`
  label: DeductionTotalBlock;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  color: ${(props) => props.primary ? props.theme.colors.primary: props.theme.colors.grey2};
  & > b {
    font-weight: 600;
    font-size:14px !important;
  }
`

export const DeductionTotalContainerMobile = styled.div`
  label: DeductionTotalContainerMobile;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  margin: 12px;
`

export const DeductionColorBlockMobile = styled.div`
  label: DeductionColorBlockMobile;
  text-align: center;
  width: 100%;
  background-color: ${(props) => props.theme.brand === 'Maxxia'
      ? '#003D79'
      : '#3CB387'};
  color: ${(props) => props.theme.colors.white};
  box-sizing: border-box;
  padding: 10px;
`

export const BannerInfoTitle = styled.h2`
  label: BannerInfoTitle;
  margin-bottom: 0.5rem;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '37px' : '48px')};
`

export const BannerInfoContent = styled.div`
  label: BannerInfoContent;
  margin-bottom: 0.5rem;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '20px')};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 800)};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  line-height: ${(props) => (props.theme.brand === 'Maxxia' ? '27px' : '36px')};
`
export const BannerInfolink = styled.a`
  label: BannerInfoLink;
  pointer-events: none;
  opacity: 0.3;
  text-decoration: underline;
  font-weight: 700;
`

export const AuthorizationText = styled.div`
  label: AuthorizationText;
  background-color: ${(props) => props.theme.colors.primaryLightText};
  padding: 15px;
  font-weight: ${(props) => props.theme.font.weight.slightBold} !important;
  border-radius: 8px;
  display: flex;
  align-items: center;
  input[type='checkbox'] {
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
`
export const ButtonContainer = styled.div`
  label: ButtonContainer;
  display: flex;
  justify-content: space-around;
  min-width: 312px;
  @media (max-width: 719px) {
    flex-direction: column;
    height: 140px;
  }
`

export const BudgetPlannerButton = styled(PrimaryButton)`
  label: BudgetPlannerButton;
  background-color: #fff !important;
  color: ${(props) => props.theme.colors.primary} !important;
  width: 100%;
  &:hover {
    opacity: 0.8;
  }
`

export const EmissionContainer = styled.div`
  label: emissionContainer;
  padding-bottom: 30px;
`

export const EmissionContainerPdf = styled(EmissionContainer)`
  label: emissionContainerPdf;
  padding: 0px 10px 40px;
`

export const ViewPDFDiv = styled.div`
  label: ViewPDFDiv;
  display: flex;
  justify-content: end;
  @media (max-width: 719px) {
    display: inline;
    justify-content: inherit;
  }
`
export const SubMenuContainer = styled.div`
  label: SubMenuContainer;
  position: sticky;
  top: 0;
  z-index: 10;
`

export const FeeDetail = styled.div`
  label: feeDetail;
  padding-left: 24px;
  padding-top: 6px;
  padding-bottom: 6px;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
`

export const ProposalValidToDiv = styled.div`
  label: ProposalValidToDiv;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
  margin-bottom: 6px;
`

export const StyledCard = styled(Card)`
  label: StyledCard;
  box-shadow: ${(props) =>
    props.pdf ? '' : 'rgba(0, 0, 0, 0.16) 0px 2px 16px'};
  border-color: ${(props) =>
    props.pdf ? props.theme.colors.primary : props.theme.colors.borderColor};
`

export const CardHeader = styled.div`
  label: CardHeader;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 900)};
  text-transform: uppercase;
`

export const CardText = styled(Col)`
  label: CardText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`

export const CardValue = styled(Col)`
  label: CardValue;
  color: ${(props) =>
    props.colour
      ? props.colour
      : props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: right;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  @media (max-width: 719px) {
    text-align: left;
    margin-bottom: 18px;
  }
`

export const BrandDefaultText = styled.div`
  label: BrandDefaultText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const CarPriceValue = styled(Col)`
  label: CarPriceValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.primary};
  text-align: right;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
`

export const GSTSavingsValue = styled(Col)`
  label: GSTSavingsValue;
  color: ${(props) => props.theme.colors.positive};
  text-align: right;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
`

export const PDSLink = styled.a`
  label: PDSLink;
  color: ${(props) => props.theme.brand !== 'Maxxia' && '#000'};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 400 : 900)};
  text-decoration: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'normal' : 'underline'};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '18px' : '16px')};
`

export const ImageContainerDiv = styled.div`
  label: ImageContainerDiv;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`
export const ImageContainer = styled.div`
  label: ImageContainer;
  border: ${(props) => (props.theme.brand === 'Maxxia' ? null : '1px inset')};
  max-width: 457px;
`

export const ImageIndicativeText = styled.p`
  label: ImageIndicativeText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-size: 14px;
  text-align: center;
`

export const LinkText = styled.span`
  label: LinkText;
  text-decoration: underline;
  cursor: pointer;
`
